import { z } from 'zod'

export default z.object({
  __typename: z.literal('Equipment').default('Equipment'),
  id: z.string(),
})
